(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[403],{

/***/ 7244:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[business]/access/[category]",
      function () {
        return __webpack_require__(1214);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(7868);
;// CONCATENATED MODULE: ./components/icons/Icons/IconArrowRight.tsx


const IconArrowRight = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "icon-arrow",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5 9L8 6L5 3",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_IconArrowRight = (IconArrowRight);

// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.module.scss
var breadcrumb_module = __webpack_require__(3964);
var breadcrumb_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumb_module);
;// CONCATENATED MODULE: ./components/breadcrumb/breadcrumb.tsx





const Breadcrumb = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { breadcrumbs , type  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadcrumb_module_default()).breadcrumbContainer + " " + (breadcrumb_module_default())["".concat(type)],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (breadcrumb_module_default()).breadcrumb,
            children: (breadcrumbs || []).map((breadcrumb, index)=>{
                const linkTags = {};
                var _link;
                const linkUrl = (0,LangHelper/* localifyLink */.Bj)((_link = breadcrumb.link) !== null && _link !== void 0 ? _link : "", locale);
                if (linkUrl) {
                    linkTags.href = "/".concat(locale).concat(linkUrl);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumb_module_default()).separator,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_IconArrowRight, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumb_module_default()).breadcrumbName,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                ...linkTags,
                                target: "_self",
                                className: (breadcrumb_module_default()).link,
                                dangerouslySetInnerHTML: {
                                    __html: "".concat(breadcrumb.name)
                                }
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var breadcrumb = (Breadcrumb);


/***/ }),

/***/ 8816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ category_hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(3431);
// EXTERNAL MODULE: ./shared/sharedContext.tsx
var sharedContext = __webpack_require__(6224);
// EXTERNAL MODULE: ./components/icons/index.tsx + 82 modules
var icons = __webpack_require__(3203);
// EXTERNAL MODULE: ./components/category-filter/category-filter.module.scss
var category_filter_module = __webpack_require__(4184);
var category_filter_module_default = /*#__PURE__*/__webpack_require__.n(category_filter_module);
;// CONCATENATED MODULE: ./components/category-filter/category-filter.tsx





const CategoryFilter = (props)=>{
    const [isShownCategories, setIsShownCategories] = (0,react.useState)(false);
    const categoryCtx = (0,react.useContext)(sharedContext/* CategoryCtx */.N);
    const handleCategories = (category)=>{
        if (categoryCtx.categoriesToFilter.some((_category)=>_category.id === category.id)) {
            return categoryCtx.setCategoriesToFilter(categoryCtx.categoriesToFilter.filter((_category)=>_category.id !== category.id));
        }
        return categoryCtx.setCategoriesToFilter([
            ...categoryCtx.categoriesToFilter,
            category
        ]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (category_filter_module_default()).categoryFilter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_filter_module_default()).filterButton + " " + (category_filter_module_default())[isShownCategories ? "open" : "close"],
                onClick: ()=>setIsShownCategories(!isShownCategories),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Filter */.T.Filter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Filter"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_filter_module_default()).filterIconDown,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Down */.T.Down
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_filter_module_default()).categories + " " + (category_filter_module_default())[isShownCategories ? "open" : "close"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (category_filter_module_default()).categoriesList,
                    children: (categoryCtx.allCategories || []).map((category, index)=>{
                        const isItemChecked = categoryCtx.categoriesToFilter.some((_category)=>_category.id === category.id);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (category_filter_module_default()).categoryName + " " + (category_filter_module_default())[isItemChecked ? "checked" : "unCheck"],
                            onClick: ()=>handleCategories(category),
                            children: category.name
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var category_filter = (CategoryFilter);

// EXTERNAL MODULE: ./components/category-hero/category-hero.module.scss
var category_hero_module = __webpack_require__(9529);
var category_hero_module_default = /*#__PURE__*/__webpack_require__.n(category_hero_module);
;// CONCATENATED MODULE: ./components/category-hero/category-hero.tsx






const CategoryHero = (props)=>{
    const { categoryHeroTitle , breadcrumbs , categoryHeroDescription , backgroundColor ="Orca Pastel" , backgroundCoverContent =true , showFilter =true  } = props;
    const breadcrumbIncluded = breadcrumbs && breadcrumbs.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((category_hero_module_default()).categoryHero, {
            [(category_hero_module_default()).breadcrumb]: breadcrumbIncluded
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((category_hero_module_default()).categoryHeroBackground, (category_hero_module_default())["categoryHeroBackground".concat(backgroundColor.replace(" ", ""))], {
                    [(category_hero_module_default()).categoryHeroBackgroundCover]: backgroundCoverContent
                })
            }),
            breadcrumbIncluded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_hero_module_default()).breadcrumbs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                    type: "dark",
                    breadcrumbs: breadcrumbs
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (category_hero_module_default()).categoryName,
                children: categoryHeroTitle
            }),
            categoryHeroDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (category_hero_module_default()).categoryDescription,
                children: categoryHeroDescription
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_hero_module_default()).categoryFilter,
                children: showFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(category_filter, {}) : null
            })
        ]
    });
};
/* harmony default export */ var category_hero = (CategoryHero);


/***/ }),

/***/ 2135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2132);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);




const CSP = __webpack_require__(5331);
function MetaBlock(props) {
    const { title , description , leadImage  } = props;
    const [isAfterpay, setIsAfterpay] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setIsAfterpay(window.location.host.startsWith("afterpay.com"));
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "Content-Security-Policy",
                content: CSP
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "ZJMu9MsvjHJwPn0kcq31cioCrPxAw0HHWqWOqXpq1-Y"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            !isAfterpay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            leadImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: leadImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:image",
                        content: leadImage
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 7048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7650);
/* harmony import */ var _helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5443);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3203);
/* harmony import */ var _newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(425);
/* harmony import */ var _newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const iconArrowRight = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M0.5 8.5H15.5" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n<path d="M10.5 3.5L15.5 8.5L10.5 13.5" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>';
const NewsletterSignUpSection = (props)=>{
    const [newsLetterSignUp, setNewsletterSignUp] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isShowMessage, setIsShowMessage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { ref , inView  } = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)({
        triggerOnce: true
    });
    const handleOnSuccess = ()=>{
        (0,_helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .setCookie */ .d8)("NewsletterSignUp", "true");
        setIsShowMessage(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const newsletterSignUpCookie = (0,_helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("NewsletterSignUp");
        if (newsletterSignUpCookie && newsletterSignUpCookie !== "") {
            setNewsletterSignUp(true);
        }
    }, [
        newsLetterSignUp
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!inView) {
            return;
        }
        const MktoForms2 = window.MktoForms2;
        const loadMarketoForm = ()=>{
            const newScriptElement = document.createElement("script");
            newScriptElement.onload = ()=>{
                triggerMarketoForm();
            };
            newScriptElement.setAttribute("src", "https://business.afterpay.com/js/forms2/js/forms2.min.js");
            document.body.appendChild(newScriptElement);
        };
        const triggerMarketoForm = ()=>{
            var ref;
            if (!window.MktoForms2) {
                return;
            }
            (ref = window.MktoForms2) === null || ref === void 0 ? void 0 : ref.loadForm("//business.afterpay.com", "539-RJA-633", 1064, function(form) {
                form.getFormElem().find("button.mktoButton").html('<div class="button-submit"><div class="button-submit-title">Subscribe Now</div>'.concat(iconArrowRight, "</div>"));
                form.getFormElem().find("input.mktoEmailField").attr("placeholder", "Enter your email here...");
                form.onSuccess(function() {
                    handleOnSuccess();
                    return false;
                });
            });
        };
        if (!MktoForms2) {
            loadMarketoForm();
        } else {
            triggerMarketoForm();
        }
    }, [
        inView
    ]);
    if (newsLetterSignUp) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSection),
            ref: ref,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionInfoBackground),
                    children: " "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionInfo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionTitle),
                        children: "Get small business advice and insights straight to your inbox."
                    })
                }),
                isShowMessage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionAfterSubmit),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            type: _icons__WEBPACK_IMPORTED_MODULE_2__/* .IconType.Subscribed */ .T.Subscribed
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                "Thanks!",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "You're now subscribed."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                    id: "mktoForm_1064",
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionForm)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewsletterSignUpSection);


/***/ }),

/***/ 5331:
/***/ (function(module) {

"use strict";
// Used for Staging and Production

const CSP_SETTINGS = {
    "script-src": [
        "'self'",
        "'unsafe-eval'",
        "'unsafe-inline'",
        "*.afterpay.com",
        "*.clearpay.co.uk",
        "*.clearpay.com",
        "*.googleapis.com",
        "public.fbot.me",
        "static.fbot.me",
        "campaign.fbot.me",
        "lcx-embed.bambuser.com",
        "www.googletagmanager.com",
        "*.onetrust.com",
        "cdn.branch.io",
        "sc-static.net",
        "snap.licdn.com",
        "connect.facebook.net",
        "munchkin.marketo.net",
        "www.googleadservices.com",
        "cdn.dashhudson.com",
        "djnf6e5yyirys.cloudfront.net",
        "cdn.builder.io",
        "t.contentsquare.net",
        "www.google-analytics.com",
        "googleads.g.doubleclick.net",
        "app.link",
        "v5tufwer.micpn.com",
        "pi.pardot.com",
        "tag.clearbitscripts.com/v1/pk_ba428737ee82fd942f13030da0c2629b/tags.js",
        "tag.rmp.rakuten.com",
        "metadata-static-files.sfo2.cdn.digitaloceanspaces.com/pixel/lp.js",
        "x.clearbitjs.com/v2/pk_ba428737ee82fd942f13030da0c2629b/tracking.min.js",
        "x.clearbitjs.com/v2/pk_ba428737ee82fd942f13030da0c2629b/destinations.min.js",
        "analytics.tiktok.com/i18n/pixel/events.js",
        "analytics.tiktok.com/i18n/pixel/config.js",
        "analytics.tiktok.com/i18n/pixel/identify.js",
        "bat.bing.com",
        "afterpay-business-site.vercel.app",
        "business.dijitally.com",
        "*.ads-twitter.com",
        "js.adsrvr.org",
        "cdn.bizible.com",
        "analytics.twitter.com",
        "t.co",
        "bat.bing.com",
        "widget.trustpilot.com"
    ],
    "img-src": [
        "'self'",
        "data:",
        "*.afterpay.com",
        "*.clearpay.co.uk",
        "maps.gstatic.com",
        "*.googleapis.com",
        "*.ggpht",
        "cdn.builder.io",
        "static.fbot.me",
        "www.google.co.nz",
        "www.google.co.uk",
        "www.google.com",
        "www.google.com.au",
        "www.googletagmanager.com",
        "px.ads.linkedin.com",
        "www.facebook.com",
        "p.adsymptotic.com",
        "cdn.branch.io",
        "www.google-analytics.com",
        "public.fbot.me",
        "connect.facebook.net",
        "*.onetrust.com",
        "cdn.dashhudson.com",
        "likeshop.me",
        "track.linksynergy.com",
        "consent.linksynergy.com",
        "www.kmart.com.au",
        "www.bigw.com.au/",
        "www.pacsun.com",
        "afterpay-business-site.vercel.app",
        "business.dijitally.com",
        "cdn.bizible.com",
        "*.google.ie",
        "bat.bing.com",
        "t.co",
        "cdn.bizibly.com",
        "cdn.builder.com"
    ],
    "object-src": [
        "'none'"
    ],
    "base-uri": [
        "'none'"
    ]
};
const CSP = Object.entries(CSP_SETTINGS).reduce((previousValue, param)=>{
    let [key, cspValues] = param;
    const cspString = cspValues.join(" ");
    return "".concat(previousValue, " ").concat(key, " ").concat(cspString, ";");
}, "").trim();
module.exports = CSP;


/***/ }),

/***/ 1214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _components_article_grid_article_grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1834);
/* harmony import */ var _components_category_hero_category_hero__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8816);
/* harmony import */ var _components_layouts_default_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4670);
/* harmony import */ var _components_newsletter_signup_section_newsletter_signup_section__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7048);
/* harmony import */ var _helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1198);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7868);
/* harmony import */ var _shared_sharedContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6224);
/* harmony import */ var _styles_generic_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4256);
/* harmony import */ var _styles_generic_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_generic_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2135);











const CategoryPage = (param)=>{
    let { category , initialArticles , footerItems , categories  } = param;
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_7__/* .useLocale */ .bU)();
    const [articles, setArticles] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialArticles !== null && initialArticles !== void 0 ? initialArticles : []);
    const [categoriesToFilter, setCategoriesToFilter] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [allCategories, setAllCategories] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [offsetArticle, setOffsetArticle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [isArticleLoadMore, setIsArticleLoadMore] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (offsetArticle !== 0) {
            loadMoreArticles();
        }
    }, [
        offsetArticle
    ]);
    if (!category) {
        return null;
    }
    const loadMoreArticles = async ()=>{
        await setIsArticleLoadMore(true);
        const articlesByCategory = await (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_6__/* .getArticlesByCategory */ .Zd)({
            locale,
            offset: offsetArticle,
            limit: 10,
            categoryIds: [
                category === null || category === void 0 ? void 0 : category.id
            ]
        });
        await setArticles([
            ...articles.concat(articlesByCategory)
        ]);
        await setIsArticleLoadMore(false);
    };
    const categoryBreadcrumbs = [
        {
            name: "Business",
            link: "/business"
        },
        {
            name: "Access",
            link: "/business/access"
        },
        {
            name: category.name,
            link: ""
        }
    ];
    var _longName;
    const categoryTitleName = (_longName = category.longName) !== null && _longName !== void 0 ? _longName : category.name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_default_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        footerItems: footerItems,
        categories: categories,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                title: categoryTitleName,
                description: category.description,
                leadImage: category.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_shared_sharedContext__WEBPACK_IMPORTED_MODULE_8__/* .CategoryCtx.Provider */ .N.Provider, {
                value: {
                    allCategories,
                    categoriesToFilter,
                    setCategoriesToFilter,
                    setAllCategories
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_category_hero_category_hero__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        categoryHeroTitle: categoryTitleName,
                        breadcrumbs: categoryBreadcrumbs,
                        backgroundColor: category.isSeries ? "Blum" : "Orca Pastel"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: _styles_generic_module_scss__WEBPACK_IMPORTED_MODULE_10__["page-layout"],
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_article_grid_article_grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            articles,
                            setOffsetArticle,
                            offsetArticle,
                            isLoadingMoreArticles: isArticleLoadMore
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_newsletter_signup_section_newsletter_signup_section__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CategoryPage);


/***/ }),

/***/ 3964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"breadcrumb_breadcrumbContainer__PXHE5","light":"breadcrumb_light__eyy6t","separator":"breadcrumb_separator__0KuRL","dark":"breadcrumb_dark__T0QBm","container":"breadcrumb_container__WEljr","breadcrumb":"breadcrumb_breadcrumb__4T6Pp"};

/***/ }),

/***/ 4184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryFilter":"category-filter_categoryFilter__F_OO4","filterButton":"category-filter_filterButton__NHaXZ","filterIconDown":"category-filter_filterIconDown__xk2Wn","close":"category-filter_close__tyvrf","categories":"category-filter_categories__v8HZt","open":"category-filter_open__MIMNv","categoriesList":"category-filter_categoriesList__OG8zb","categoryName":"category-filter_categoryName__irctx","checked":"category-filter_checked__C6PCV"};

/***/ }),

/***/ 9529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryHero":"category-hero_categoryHero__kMcFU","breadcrumb":"category-hero_breadcrumb__1N_HC","categoryHeroBackground":"category-hero_categoryHeroBackground__euo6l","breadcrumbs":"category-hero_breadcrumbs__nSw__","categoryHeroBackgroundCover":"category-hero_categoryHeroBackgroundCover__ufVX0","categoryHeroBackgroundOrcaPastel":"category-hero_categoryHeroBackgroundOrcaPastel__pfx1q","categoryHeroBackgroundBlum":"category-hero_categoryHeroBackgroundBlum__0i4Yg","categoryName":"category-hero_categoryName__IpP6L","categoryDescription":"category-hero_categoryDescription__xo2PS","categoryFilter":"category-hero_categoryFilter__1LjhT"};

/***/ }),

/***/ 425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsletterSignUpSection":"newsletter-signup-section_newsletterSignUpSection__HDAV0","newsletterSignUpSectionInfo":"newsletter-signup-section_newsletterSignUpSectionInfo__QmDXv","newsletterSignUpSectionTitle":"newsletter-signup-section_newsletterSignUpSectionTitle__z_Vcu","newsletterSignUpSectionDescription":"newsletter-signup-section_newsletterSignUpSectionDescription__xkN5J","newsletterSignUpSectionForm":"newsletter-signup-section_newsletterSignUpSectionForm__TmS4Y","newsletterSignUpSectionFormInput":"newsletter-signup-section_newsletterSignUpSectionFormInput__xkKkF","newsletterSignUpSectionAfterSubmit":"newsletter-signup-section_newsletterSignUpSectionAfterSubmit__9Eqeo","fade-in":"newsletter-signup-section_fade-in__f9__6","newsletterSignUpSectionFormBtnSubmit":"newsletter-signup-section_newsletterSignUpSectionFormBtnSubmit__xyl1K","newsletterSignUpSectionInfoBackground":"newsletter-signup-section_newsletterSignUpSectionInfoBackground__5_ixx","video-spin":"newsletter-signup-section_video-spin__1wgzd"};

/***/ }),

/***/ 4256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-layout":"generic_page-layout__xvmcs","--no-top-padding":"generic_--no-top-padding__nEzZP","marketing-resource-center-layout":"generic_marketing-resource-center-layout__tdFo5","resource-centre-hero-container":"generic_resource-centre-hero-container__RZrEE","divider":"generic_divider__9jAmH","content":"generic_content__y5B5C","top-navigation":"generic_top-navigation__39atH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [67,613,774,888,179], function() { return __webpack_exec__(7244); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);